import React, { Component } from 'react';
import { connect } from 'react-redux';
import { store } from '../..';
import { ADDTAB } from '../../common/sysco-ui-components/store/actions/actionTypes';
import supplierWebDashboardContainer from '../../containers/supplierWebDashboardContainer';
import history from '../../utils/history';
import Axios from "axios";
import { VERIFY_SESSION_PATH } from '../../config/path';

class Dashboard extends Component {
    static displayName = 'Dashboard';
    async componentDidMount() {
        try {
            const authCheck = await Axios.get(VERIFY_SESSION_PATH);
            if (authCheck.data.authenticated) {
                store.dispatch({
                    type: ADDTAB,
                    payload: {
                        title: "Dashboard",
                        eventKey: supplierWebDashboardContainer,
                        data: {}
                    }
                });
            } else {
                history.push("/");
            }
        } catch (error) {
            console.error("Authentication check failed:", error);
            history.push("/");
        }
    }
    render() {
        return (
            <div>
                
            </div>
        );
    }
}
export default connect()(Dashboard);
